'use client';
import { forwardRef, HTMLAttributes } from 'react';
import NextLink, { LinkProps as NextLinkProps } from 'next/link';

export type LinkProps = {
	children: React.ReactNode;
} & HTMLAttributes<HTMLAnchorElement> &
	NextLinkProps;

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(
	({ href, className, children, ...rest }, ref) => {
		return (
			<NextLink href={href} className={`text-sm ${className}`} ref={ref} {...rest}>
				{children}
			</NextLink>
		);
	}
);

export default Link;
